const searchComponents = document.querySelectorAll('.search-component');

searchComponents.forEach(Search => {
  const searchButton = Search.querySelector('.searchButton');
  const searchPanel = Search.querySelector('.search-panel');
  const col = Search.querySelector('.search-panel .col');
  const Input = Search.querySelector('input');
  const overlay = document.getElementById('overlay-search');
  const insideCloseBtn = Search.querySelector('.close-search-inside');

  if (!Input || !searchPanel || !overlay) return;

  // Fonction fadeIn desktop
  function fadeIn(el, duration = 100) {
    el.style.opacity = 0;
    el.style.display = 'block';
    let last = +new Date();
    let tick = function () {
      el.style.opacity = +el.style.opacity + (new Date() - last) / duration;
      last = +new Date();
      if (+el.style.opacity < 1) {
        requestAnimationFrame(tick);
      }
    };
    tick();
  }

  Input.addEventListener('focusin', function () {
    const isMobile = window.innerWidth <= 1200;

    Search.classList.add('expand');
    if (col) col.style.position = 'unset';
    if (searchButton) searchButton.removeAttribute('disabled');


    if (isMobile) {
      // Version mobile - offcanvas
      document.querySelector('.header-wrapper-content')?.classList.add('hide-logo');
      document.body.classList.add('search-open');
      searchPanel.classList.add('mobile-offcanvas', 'show');
      overlay.classList.add('show');
    } else {
      // Version desktop
      fadeIn(searchPanel, 100);
      overlay.style.display = 'block';
    }
  });

  // Fonction overlay
  overlay.addEventListener('click', function () {
    const isMobile = window.innerWidth <= 1200;

    if (isMobile) {
      searchPanel.classList.remove('show');
      overlay.classList.remove('show');
      document.querySelector('.header-wrapper-content')?.classList.remove('hide-logo');
      document.body.classList.remove('search-open');
    } else {
      searchPanel.style.display = 'none';
      overlay.style.display = 'none';
    }

    if (col) col.style.position = 'relative';
    if (searchButton) searchButton.setAttribute('disabled', 'disabled');
    Search.classList.remove('expand');


  });

  // fermture offcanvas dans un input
  if (insideCloseBtn) {
  insideCloseBtn.addEventListener('click', function () {
    const isMobile = window.innerWidth <= 1200;
    if (isMobile) {
      searchPanel.classList.remove('show');
      overlay.classList.remove('show');
      document.querySelector('.header-wrapper-content')?.classList.remove('hide-logo');
      document.body.classList.remove('search-open');
      if (col) col.style.position = 'relative';
      if (searchButton) searchButton.setAttribute('disabled', 'disabled');
      Search.classList.remove('expand');
    }
  });
}
});
